// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inventory-alert[data-v-3f2f948a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 10px;\n.alert-error {\n    margin-left: 10px;\n}\n}\n.el-icon-delete[data-v-3f2f948a] {\n  margin-left: 4px;\nspan {\n    margin-left: 4px;\n}\n}\n.add-btn[data-v-3f2f948a] {\n  position: fixed;\n  right: 0;\n  top: 450px;\n  z-index: 99\n}\n\n\n", ""]);
// Exports
module.exports = exports;
